/* eslint-disable no-loop-func */
/**
 * Generates a unique identifier (URN) with at least 13 characters,
 * incorporating date, time, and randomness.
 *
 * @returns {string} The generated unique identifier.
 */
export default function GenerateURN() {
    const date = new Date();
  
    // Get year (2 digits), day of year (3 digits)
    const year = date.getFullYear().toString().substr(-2); // Last 2 digits of year
    const dayOfYear = Math.floor(
      (date - new Date(date.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24
    )
      .toString()
      .padStart(3, "0"); // Ensure it's always 3 digits
  
    // Time components padded to ensure consistent length
    const hour = date.getHours().toString().padStart(2, "0"); // Always 2 digits
    const minute = date.getMinutes().toString().padStart(2, "0"); // Always 2 digits
    const seconds = date.getSeconds().toString().padStart(2, "0"); // Always 2 digits
    const milliseconds = date.getMilliseconds().toString().padStart(3, "0"); // Always 3 digits
  
    // Combine components to form at least a 13-character URN
    let urn = year + dayOfYear + hour + minute + seconds + milliseconds;
  
    // Ensure at least 13 characters (already guaranteed by components)
    if (urn.length < 13) {
      urn = urn.padEnd(13, "0"); // If somehow shorter, pad with zeros (shouldn't be needed)
    }
  
    // Store recently generated URNs for tracking
    GenerateURN.recentlyGeneratedURNs.push({
      urn,
      generatedAt: date.getTime(),
    });
  
    // Limit stored URNs to avoid excessive memory usage
    GenerateURN.recentlyGeneratedURNs = GenerateURN.recentlyGeneratedURNs.slice(
      -100
    );
  
    return urn;
  }
  
  // Initialize storage for recently generated URNs
  GenerateURN.recentlyGeneratedURNs = [];
  